import React, { Component } from "react";
import { Table, Segment } from "semantic-ui-react";

class EmployeeSkills extends Component {
  renderEmployeeSkills(skills) {
    if (skills && skills.length > 0) {
      return skills.map(emp => {
        return (
          <Table.Row key={emp.Id}>
            <Table.Cell>
              {emp.SkillName}
            </Table.Cell>
            <Table.Cell>
              {emp.Level}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  render() {
    let { skills } = this.props;
    return (
      <Segment.Group className="BasicInfoCnt">
        <Segment basic>
          <h1 className="textStyleHeading">Employee Skills</h1>
          <Table singleLine>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Skill Name</Table.HeaderCell>
                <Table.HeaderCell>Skill Level</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderEmployeeSkills(skills)}
            </Table.Body>
          </Table>
        </Segment>
      </Segment.Group>
    );
  }
}

export default EmployeeSkills;
